import { useQuery } from '@tanstack/react-query';
import getApi from '@/lib/axios';
import { ExtractFnReturnType } from '@/lib/react-query';

async function getRaioxAlunos(params): Promise<any> {
  const api = await getApi();
  const { data } = await api.get<any>('/raiox/alunos/', {params});
  return data;
}

type QueryFnType = typeof getRaioxAlunos;

function useRaioxAlunos(params) {
  return useQuery<ExtractFnReturnType<QueryFnType>>({
    queryKey: ['fetch-raiox-alunos', params],
    queryFn: () =>  getRaioxAlunos(params),
  });
}

export { useRaioxAlunos };
